/**
 * Styles for Arena empty state — animated monkey mascot + soft halo.
 */

import { Platform, StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getArenaEmptyStateMonkeyStyles = (theme: Theme) =>
  StyleSheet.create({
    halo: {
      width: 184,
      height: 184,
      borderRadius: 92,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: `${theme.primaryLight}30`,
      borderWidth: 2,
      borderColor: `${theme.primaryLight}55`,
      marginBottom: 10,
      ...(Platform.OS === 'android' && {
        elevation: 8,
      }),
      ...(Platform.OS === 'web' && {
        boxShadow: `0 14px 36px ${theme.primary}26`,
      }),
    },
    mascotAnimatedWrap: {
      width: 148,
      height: 148,
      alignItems: 'center',
      justifyContent: 'center',
    },
    mascotImage: {
      width: 136,
      height: 136,
    },
  });
